import React from "react";
import CalendarSection from "../CalendarSection";

const Calendar = () => {
  return <CalendarSection />;
};

export default Calendar;
